import { Injectable, linkedSignal, Signal, WritableSignal } from '@angular/core';
import { FieldTree } from '@angular/forms/signals';
import { castToCustomFieldTree, keys } from '@ps-gui/shared-utils';

@Injectable({
  providedIn: 'root',
})
export class FormFieldStateService {
  private readonly _formFieldStates = new Map<
    string,
    {
      disabled: WritableSignal<boolean>;
      hidden: WritableSignal<boolean>;
      touched: WritableSignal<boolean>;
      invalid: WritableSignal<boolean>;
    }
  >();

  getFormFieldState(fieldName: string) {
    return this._formFieldStates.get(fieldName);
  }

  addFormFieldState(
    fieldName: string,
    disbaled: Signal<boolean>,
    hidden: Signal<boolean>,
    touched: Signal<boolean>,
    invalid: Signal<boolean>,
  ) {
    this._formFieldStates.set(fieldName, {
      disabled: linkedSignal(() => disbaled()),
      hidden: linkedSignal(() => hidden()),
      touched: linkedSignal(() => touched()),
      invalid: linkedSignal(() => invalid()),
    });
  }

  removeFormFieldState(fieldName: string) {
    this._formFieldStates.delete(fieldName);
  }

  resetAllTouchedStatesByForm<T extends object>(fieldTree: FieldTree<T>) {
    const castedFieldTree = castToCustomFieldTree(fieldTree);
    keys(fieldTree().value()).map((fieldName) => {
      const name = castedFieldTree[fieldName as keyof T]().name();
      this.getFormFieldState(name)?.touched.set(false);
    });
  }
}
